import React,{useState} from "react";
import axiosInstance from "../../services/axios";
import { ActionTypes } from "../action-type";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";



export const getAvatar = () => async (dispatch) =>{
    try{
        const response = await axiosInstance.get("/avatar/");
        const {data} = response;
        dispatch({
            type:ActionTypes.AVATAR,
            payload:data
        })
    }
    catch(err){
        console.log(err)
    }
    
}

export const createAvatar = (values)=>async(dispatch)=>{
    try {
        values.profile_exist=1
        const response = await axiosInstance.post("/avatar/create", values);
        const {data} = response
        dispatch({
            type:ActionTypes.AVATAR,
            payload:data
        })

    }
    catch(err){
        throw(err)
    }
}


export const updateAvatar = (values)=>async(dispatch)=>{
    try{

        const response = await axiosInstance.put("/avatar/update",values);
        const {data} = response
        dispatch({
            type:ActionTypes.AVATAR,
            payload:data
        })

    }
    catch(err){
        throw(err)
    }
}


export const changeGender = (gender)=> async(dispatch)=>{
    dispatch({
        type:ActionTypes.CHANGE_GENDER,
        payload:{gender}
    })
}